import { useEffect } from 'react';

export const useNavigation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToElement = (elementId) => {
    const el = document.getElementById(elementId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return { scrollToElement };
};
